module.exports = __webpack_public_path__ + "static/media/i_de.d7e96640.pdf";